import { VdpFeatures } from '../components/vdp/features.vue';
Vue.component('vdp-features', VdpFeatures);